/**
 * Endereço de acesso (E1, 21/10/2026): o host do PABX/SBC/APP onde o cliente fica (ex.: com8dn.ipcom.app.br, ou o
 * compartilhado sbc.ipcom.app.br). Mora no cadastro do cliente; o DDR escolhe um dos endereços do cliente dele.
 */

/** Mesma normalização do backend (host-de-acesso.util): minúsculo, sem http(s)://, sem caminho nem barra final. */
export const normalizarHost = (valor?: string | null): string =>
  String(valor ?? '').trim().toLowerCase().replace(/^https?:\/\//, '').replace(/[/?#].*$/, '').replace(/\.+$/, '');

/**
 * D1 (Heitor, 21/10/2026): sugerir o endereço pelo PREFIXO do Domínio SIP, só com clique. Medido em produção no mesmo
 * dia: em 64 dos 81 pares cliente × endereço o prefixo bate (agger.ipcom.com.br → agger.ipcom.app.br); em 8 não bate
 * (ODONTOCOMPANY usa odontocompanybarbacena no SIP, COM8DN e JERAB estão no sbc compartilhado…). Por isso é sugestão,
 * nunca regra. `siptrunk` fica de fora: é o domínio SIP genérico de 3 clientes, e siptrunk.ipcom.app.br não existe.
 */
export function sugestaoPeloDominioSip(dominioSip?: string | null): string | null {
  const d = normalizarHost(dominioSip);
  const m = d.match(/^([a-z0-9-]+)\.ipcom\.com\.br$/);
  if (!m || m[1] === 'siptrunk') return null;
  return `${m[1]}.ipcom.app.br`;
}

/** Os endereços em comum a todas as listas (por id), na ordem do host. Lista vazia de entrada = nenhum em comum. */
export function enderecosEmComum<T extends { id: number; host: string }>(listas: T[][]): T[] {
  if (listas.length === 0) return [];
  const [primeira, ...resto] = listas;
  return primeira
    .filter((e) => resto.every((l) => l.some((x) => x.id === e.id)))
    .sort((a, b) => a.host.localeCompare(b.host));
}
